"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dam = void 0;
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const Pond_1 = require("./Pond");
const typeName = 'Dam';
class Dam extends Pond_1.Pond {
    constructor(ob) {
        var _a, _b;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.subType = (_b = ob.subType) !== null && _b !== void 0 ? _b : DefinitionAndHelpers_1.DamShape.GULLY;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.Dam = Dam;
